// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cloud_logic': 'enable',
    'aws_cloud_logic_custom': [{"id":"99ngkgf4q1","name":"lexaSpeech","description":"Speech functionality for Lexa Reading app","endpoint":"https://tu1tpnvlx0.execute-api.us-east-2.amazonaws.com/Development","region":"us-east-1","paths":["/RhymesWith","/RhymesWith/123","/Stream","/Stream/123","/TextToSpeech","/TextToSpeech/123"]},{"id":"56hkv3f0n6","name":"AmiraSpeechStreamAPI-stage","description":"","endpoint":"https://56hkv3f0n6.execute-api.us-east-1.amazonaws.com/Prod","region":"us-east-1","paths":["/stream"]}],
    'aws_cognito_identity_pool_id': 'us-east-2:04a725e2-ca0f-4953-bfba-141ca5db03e7',
    'aws_cognito_region': 'us-east-2',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'lexaspeechapi-hosting-mobilehub-1085629480',
    'aws_content_delivery_bucket_region': 'us-east-2',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd19svf0viwztrx.cloudfront.net',
    //'aws_mobile_analytics_app_id': '413bdbc4d708495a84646e7cc743f24f',
    //'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'ab4ef4b4-1e57-4437-b677-d6333e2e276f',
    'aws_project_name': 'lexa-speech-api',
    'aws_project_region': 'us-east-2',
    'aws_resource_bucket_name': 'lexaspeechapi-deployments-mobilehub-1085629480',
    'aws_resource_name_prefix': 'lexaspeechapi-mobilehub-1085629480',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'lexaspeechapi-userfiles-mobilehub-1085629480',
    'aws_user_files_s3_bucket_region': 'us-east-2',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-2_cYcaPNqfg',
    'aws_user_pools_web_client_id': '7sq870peb6a89ibhedcociti6',
    "aws_appsync_graphqlEndpoint": "https://l55tkeemhbbzboyp67avzpptrm.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AWS_IAM",
}

export default awsmobile;
